import { useState } from 'react'
import toast from 'react-hot-toast'
import { useMutation } from '@apollo/client'

import Button from 'shared/ui/Button_2'
import Flex from 'shared/ui/Flex'
import Input from 'shared/ui/Input'
import IslandModal from 'shared/components/modals/IslandModal'
import { BULK_DELETE_PROJECTS } from 'data/layoutcreator/mutations/admin'

interface BulkDeleteProjectsModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const BulkDeleteProjectsModal: React.FC<BulkDeleteProjectsModalProps> = ({
  isOpen,
  onClose,
}) => {
  const [projectIds, setProjectIds] = useState('')
  const [deleteProjects] = useMutation(BULK_DELETE_PROJECTS)

  const handleDelete = async () => {
    const ids = projectIds
      .split(',')
      .map((id) => id.trim())
      .filter((id) => id.length > 0);

    if (ids.length === 0) {
      toast.error('No projects found')
      return;
    }

    const toastId = toast.loading('Deleting projects...')

    try {
      const { data, errors } = await deleteProjects({
        variables: { projectIds: ids }
      })

      toast.dismiss(toastId)

      if (errors) {
        toast.error('Failed to delete projects')
        return
      }

      if (data) {
        const deletedCount = data.bulkDeleteProjects
        toast.success(`Successfully deleted ${deletedCount} project${deletedCount === 1 ? '' : 's'}`)
        onClose()
        setProjectIds('')
      }
    } catch (error: any) {
      toast.dismiss(toastId)
      toast.error(error.message || 'Failed to delete projects')
    }
  }

  return (
    <IslandModal
      isOpen={isOpen}
      closeModal={onClose}
      width={600}
      title="Bulk Delete Projects"
    >
      <Flex direction="column">
        <Flex direction="column" rowGap={16}>
          <Input
            value={projectIds}
            onChange={setProjectIds}
            label="Project IDs"
            placeholder="e.g., 123, 456, 789"
          />
        </Flex>

        <Flex marginTop={46}>
          <Button
            intent="destructive"
            textId="Delete"
            size="lg"
            isDisabled={!projectIds}
            onPress={handleDelete}
          />
        </Flex>
      </Flex>
    </IslandModal>
  )
} 